import React, { Suspense, useEffect, useState } from "react";
import SnackbarProvider from "react-simple-snackbar";
import { useSelector, useDispatch } from "react-redux";
// import { chatScript } from "../src/util/chatBotUtils";
import { isChatHiddenForRoute, isChatSupportedForRegion } from "./util/chatBotUtils";
import * as Actions from "./store/actions/global/global";
import "./App.css";
import Routes from "./Routes";
import Cookies from "js-cookie";
import AgentCoreChat from "./components/agentCoreChat";
// START - REDBALL CONFIG
import { useAuth0 } from "@auth0/auth0-react";
import { REDBALL_FEATURE_TOGGLE } from "./constants/appConstants";
import { checkNonQADomain, checkImpersonateUser } from "./util/util";
import { Loader } from "@vds/loaders";
import { CountryListProvider } from "./contexts/CountryListContext";
// END - REDBALL CONFIG
function App() {
  const nonQADomain = checkNonQADomain();
  const checkImpersonate = checkImpersonateUser();
  const { firstName, surname, emailAddress, accountUserTokenDetails, regionId, sessionExpired, logout, revealSessionExpired } = useSelector(
    (state) => state.ACCOUNT,
  );
  const dispatch = useDispatch();
  const detectSize = () => {
    dispatch(
      Actions.setwindowWidthHeight({
        width: window.innerWidth,
        height: window.innerHeight,
      }),
    );
  };
  const findRouteFromUrl = window.location.href.toString().split("#")[1];
  const [showChat, setShowChat] = useState(false);
  const [currentHash, setCurrentHash] = useState(window.location.hash);

  //START - REDBALL CONFIG
  const [isToken, setIsToken] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const { getAccessTokenSilently } = useAuth0();
  useEffect(() => {
    if (REDBALL_FEATURE_TOGGLE && nonQADomain) {
      if (!isAuthenticated && !isLoading) {
        setShowLoader(true);
        loginWithRedirect();
      } else if (isAuthenticated) {
        getCpAccessToken();
        setShowLoader(false);
      } else if (isLoading) {
        setShowLoader(true);
      }
    }
  }, [isAuthenticated, isLoading]);

  const getCpAccessToken = async () => {
    try {
      const accessToken = await getAccessTokenSilently();
      Cookies.set("cptoken", accessToken);
      setIsToken(true);
    } catch (e) {
      console.log("Error", e.message);
      loginWithRedirect();
    }
  };
  //END - REDBALL CONFIG

  useEffect(() => {
    if (accountUserTokenDetails) {
      window.pendo?.initialize({
        visitor: {
          id: accountUserTokenDetails.rowGuId,
          lang: accountUserTokenDetails.userLanguage,
        },
        account: {
          id: accountUserTokenDetails.accountId,
          regionId: accountUserTokenDetails.accountRegionId,
          lang: accountUserTokenDetails.userLanguage,
          universalAccountId: accountUserTokenDetails.universalAccountId,
        },
      });
    }
  }, [accountUserTokenDetails]);

  useEffect(() => {
    const navigationEntries = window.performance.getEntriesByType("navigation");
    if (navigationEntries.length > 0 && navigationEntries[0].type === "reload") {
      return true;
    } else {
      Cookies.set("currentRoute", findRouteFromUrl || "");
    }
  }, []);

  useEffect(() => {
    detectSize();
    window.addEventListener("resize", detectSize);
    return () => {
      window.removeEventListener("resize", detectSize);
    };
  }, []);

  // Keep currentHash in sync so chat visibility responds to manual URL changes
  // (e.g. user types /#/logout directly) — not just programmatic navigation.
  useEffect(() => {
    const onHashChange = () => setCurrentHash(window.location.hash);
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  // useEffect(() => {
  //   if (emailAddress && sessionStorage.getItem("currentPath") !== "/accessDenied" && (regionId === "840" || regionId === "124")) {
  //     chatScript(firstName, surname, emailAddress, accountUserTokenDetails.phoneNumber);
  //   }
  // }, [emailAddress, regionId]);

  useEffect(() => {
    // Extract the path portion from the hash (e.g., "#/logout" -> "/logout")
    // and check if it matches any hidden routes using the centralized utility.
    const currentPath = currentHash.split("#")[1] || "";
    const isHiddenRoute = isChatHiddenForRoute(currentPath);

    if (emailAddress && !isHiddenRoute && isChatSupportedForRegion(regionId) && !sessionExpired && !logout && !revealSessionExpired) {
      setShowChat(true);
    } else {
      setShowChat(false);
    }
  }, [emailAddress, regionId, sessionExpired, logout, revealSessionExpired, currentHash]);

  return (
    <>
      {/*//START - REDBALL CONFIG */}
      {REDBALL_FEATURE_TOGGLE && nonQADomain && !checkImpersonate ? (
        <>
          <Loader active={showLoader} fullscreen={true} />
          {isAuthenticated && isToken && (
            <Suspense fallback="loading">
              <SnackbarProvider>
                <CountryListProvider regionId={regionId}>
                  <Routes />
                </CountryListProvider>
              </SnackbarProvider>
            </Suspense>
          )}
        </>
      ) : (
        <Suspense fallback="loading">
          <SnackbarProvider>
            <CountryListProvider regionId={regionId}>
              <Routes />
            </CountryListProvider>
          </SnackbarProvider>
        </Suspense>
      )}
      {/*//END - REDBALL CONFIG */}
      {showChat && <AgentCoreChat locale={accountUserTokenDetails?.userLanguage} />}
    </>
  );
}

export default App;
